export default [
  {
    path: '/c/monitoring',
    redirect: '/c/monitoring',
    name: 'cMonitoring',
    component: () => import('@/views/NestedRoute.vue'),
    children: [
      {
        path: '',
        name: 'cMonitoringIndex',
        component: () => import('@/views/c/monitoring/Index.vue'),
        meta: {
          action: 'Lihat',
          resource: 'c-monitoring',
          pageTitle: 'Monitoring',
          breadcrumb: [
            {
              text: 'Monitoring',
              active: true,
            },
          ],
        },
      },
    ],
  },
]
